import { Controller } from "@hotwired/stimulus"

// Opens a Dialog component from anywhere on the page by its id — the dialog
// itself can live in a layout yield (e.g. content_for :modals), a different
// component, or any other part of the DOM.
//
//   <button data-controller="dialog-trigger"
//           data-dialog-trigger-id-value="purge-unconfirmed"
//           data-action="dialog-trigger#open">…</button>
//
// Or use the `dialog_trigger` helper to generate those data attributes.
export default class extends Controller {
    static values = { id: String }

    open(event) {
        const dialog = document.getElementById(this.idValue)
        if (!dialog) return

        // Only swallow the click once we know we can handle it, so a plain link
        // still works if the dialog isn't on the page.
        event?.preventDefault()
        if (!dialog.open) dialog.showModal()
    }
}
